import moment from "moment";
import { useEffect, useState } from "react";

interface TimeIntervalLabelProp {
    textLabel: string,
    dateTime: Date,
}

export default function TimeIntervalLabel(props: TimeIntervalLabelProp) {
    const [currentTime, setCurrentTime] = useState<Date>(props.dateTime);

    useEffect(() => {
        setCurrentTime(props.dateTime);

        const interval = setInterval(() => {
            setCurrentTime(moment(currentTime).subtract(1, "minute").toDate())
        }, 60 * 1000);
        return () => clearInterval(interval);
    }, [props.dateTime])

    const calculateRemaingTimeForDisplay = (pickupDate: Date) => {
        var duration = moment.duration(moment(pickupDate).diff(moment()));
        var diffInMinutes = duration.asMinutes();
        return `${diffInMinutes.toFixed(0)} mins`;
    }

    return (
        <div style={{ display:'flex', flexDirection:'row' }}>
            <p style={{color: "#9DB2CE", fontSize: 14, }}>{props.textLabel}{' '}:{' '}</p><p style={{ color: "#FA4A0C", fontSize: 14 }}>{calculateRemaingTimeForDisplay(currentTime)}</p>
        </div>

    )

}